import {type SlotWidgetConfig, WidgetType} from '@yandex-delivery/form'

export function isRadio(props: SlotWidgetConfig): boolean {
  // Если в хвосте слота есть радиобаттон, делаем весь слот кликабельным
  const type = props.slot.trail1?.type || props.slot.trail2?.type

  return type === WidgetType.RADIO || Boolean(props.slot.action)
}

export function isHeader(props: SlotWidgetConfig): boolean {
  return Boolean(props.accessibility_info?.is_header)
}

export function isBusinessOfferMock(props: SlotWidgetConfig): boolean {
  return props.widget_id === 'cargo_c2c_order_forms_b2b_lk_cargo_offer_payment_mock_slot_widget'
}

export function isBusinessPlate(props: SlotWidgetConfig): boolean {
  return props.widget_id === 'cargo_c2c_order_forms_b2b_lk_cargo_business_banner_information_slot_widget'
}
